module.exports = __webpack_public_path__ + "static/img/banner@2x.bfceb988.png";